// constants/queryKeys.ts
export const AGENCY_LIST_QUERY_KEY = ["agencies"];
export const AGENCY_EMPLOYEE_LIST_QUERY_KEY = ["agency-employees"];
export const AGENCY_EMPLOYEE_LOGIN_ACCESS_QUERY_KEY = ["agency-employee-login"];
export const AGENCY_PERMISSIONS_QUERY_KEY = ["perms"];
